import React from "react";
import logo from "../assets/images/logo.svg";
import linkedinIcon from "../assets/images/bottomLinkedin.png";
import instagramIcon from "../assets/images/bottomInstagram.png";
import aparatIcon from "../assets/images/bottomAparat.png";

const Footer = () => {
  return (
    <div className="footerContainer">
      <a href="https://pakshoma.com" target="blank">
        <img src={logo} alt="logo icon" loading="lazy"/>
      </a>
      <div className="socialContainer">
        <a
          href="https://www.linkedin.com/company/pakshomahomeappliances/"
          target="blank"
        >
          <img src={linkedinIcon} alt="linkedin icon" loading="lazy"/>
        </a>

        <a href="https://www.instagram.com/pakshomaofficial" target="blank">
          <img src={instagramIcon} alt="instagram icon" loading="lazy"/>
        </a>
        <a href="https://www.aparat.com/pakshoma" target="blank">
          <img src={aparatIcon} alt="aparat icon" loading="lazy"/>
        </a>
      </div>

      <a
        href="https://harmony.agency/"
        target="blank"
        style={{ textDecoration: "none" }}
      >
        <span>Design By Harmony</span>
      </a>
    </div>
  );
};

export default Footer;
